module.exports = __webpack_public_path__ + "img/common-doc.4a4b0386.svg";